<style scoped lang="scss">
  @import "../user";
  h3.title{
    margin-bottom: 10px;
  }
  .rules{
    padding-bottom: 10px;
    border-bottom: 2px solid #014492;
  }
  .products{
    display: flex;
    flex-wrap: wrap;
    margin:0 -15px;
    li{
      width:215px;
      margin:30px 15px 0;
      border:1px solid #E4E6EA;
      .img-box{
        cursor: pointer;
        img{
          width:213px;
          height:213px;
          display: block;
          font-size: 0;
        }
      }
      .con{
        padding:15px;
      }
      h4{
        font-size: 20px;
        color: #014492;
        cursor: pointer;
        margin-top: -2px;
        small{
          font-size: 14px;
          font-weight: normal;
          margin-left: 10px;
        }
      }
      p{
        height: 40px;
        margin:3px 0;
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      &:hover{
        p{
          color:#014492;
          text-decoration: underline;
        }
      }
      .el-button{
        width: 100%;
        margin-top: 10px;
      }
    }
  }
  .relief{
    max-height: 500px;
    overflow-y: auto;
    h4{
      margin-top: 10px;
    }
    p{
      margin-top: 10px;
    }
  }
  @media screen and (max-width: 640px){
    h3.title{
      font-size: 20px!important;
    }
    .text-primary{
      line-height: 25px;
    }
  }
  @media
  screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width:400px)
  {
    .products li{
      width: 153px!important;
    }
    .products li:nth-child(2n){
      margin-right: 0;
    }
    .products .con p{
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      word-break: break-all;
    }

    .products li .img-box{
      width: 120px;
      height: 120px;
      margin-top: 10px;
      margin-left: auto;
      margin-right: auto;
    }
    .products li .img-box img{
      width: 100% !important;
      height: 100% !important;
    }
  }
</style>
<template>
  <div class="user">
    <h3 class="title">积分商城</h3>
    <p>可用积分：<span class="text-primary">{{points.availablePoints}}</span></p>
    <div class="rules mt20">进行积分兑换前请详细阅读：
      <span class="text-primary pointer" @click="rulesVisible = true">《擎科生物积分活动政策》</span>
<!--      <span class="text-primary pointer" @click="reliefVisible = true">《免责声明》</span>-->
    </div>
    <ul class="products">
      <li v-for="item in goodsLists" :key="item.id">
        <div class="img-box" @click="toDetails(item.id)">
<!--          <img src="@/assets/images/device_3.png">-->
          <img :src="item.mainImgUrl">
        </div>
        <div class="con">
          <h4 @click="toDetails(item.id)">{{item.price}}<small>积分</small></h4>
          <p>{{item.name}}</p>
          <el-button type="primary" @click="toExchange(item)">立即兑换</el-button>
        </div>
      </li>
    </ul>
    <div class="page tr">
      <el-pagination
        :page-size="10"
        :pager-count="10"
        layout="prev, pager, next"
        :total="total"
        @current-change="changePage">
      </el-pagination>
    </div>
    <!--免责申明弹出框-->
    <el-dialog
      title="免责声明"
      :visible.sync="reliefVisible"
      width="50%">
      <div class="relief">
        <p class="text-danger">1、擎科生物积分商城规则依据国家相关法律法规及规章制度予以解释和修改，积分及兑换规则以
        擎科生物的公布为准。</p>
        <p>2、申请兑换礼品的客户请仔细阅读本须知及相关申请流程，凡进行积分兑换者视为不可撤销认可
        本须知及相关申请流程的规定；</p>
        <p class="text-danger">3、擎科生物积分商城所兑换的礼品属于客户，即申请人所在单位；申请人须确认所在单位或负责
          人已知晓此活动详情和礼品去向，有权操作客户账户视为申请人有权代表客户兑换礼品；申请
          人领取奖励礼品后视为申请人所属单位已收到该奖励礼品，擎科生物不承担礼品发放后的其他
          责任。</p>
        <p class="text-danger">4、礼品兑换申请人需为订单提交者本人，如非本人申请，请出示由申请人书面签字授权的授权
          书。</p>
        <p>5、如发现所兑换商品存在质量及数量问题，申请人需在礼品收到后5个工作日内同擎科生物或当
          地销售联系。如逾期，则视为已确认无误。</p>
        <p>6、擎科生物积分商城所展示礼品均最终以实物为准。</p>
        <p>7、根据市场变化，擎科生物保留更换礼品清单或相应积分分值的权利。可供换领、换购的礼品种
          类以申请当日擎科生物积分换领网站公布内容为准。所有兑换礼品数量有限，限量类礼品先到
          先得。若申请的限量类礼品已换完，则我公司可在同档礼品中调剂兑换，并可不事先通知换礼
          申请人。</p>
        <p>8、积分有效期为两年，以积分获得之日起开始计算，凡未在积分有效期内按照上述要求申请兑换
          礼品，逾期者视为放弃该等权利，擎科生物将不予补发；未在有效期内兑换礼品的客户，擎科
          生物不承担任何责任，请客户及时兑换。</p>
        <p>9、擎科生物有权根据活动需要取消本计划或增删、修订本规定。所有活动规定以擎科生物积分网
        站最新公布内容为准。</p>
        <p>10、擎科生物将在法律许可的范围内保留本次活动的最终解释权。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reliefVisible = false">取消</el-button>
        <el-button type="primary" @click="reliefVisible = false">确定</el-button>
      </span>
    </el-dialog>
    <!--积分礼品兑换细则弹出框-->
    <el-dialog
      title="擎科生物积分活动政策"
      :visible.sync="rulesVisible"
      width="50%">
      <div class="relief">
        <p>
          擎科生物积分活动是北京擎科生物科技股份有限公司及其子公司（简称“擎科生物”或“公司”）推出的回馈擎科科邦邦商城中订购产品的客户（简称“终端客户”）的一项奖励活动。凡终端客户在擎科科邦邦商城中订购产品，即可累积积分（公司另有规定的除外），累积的积分可用于兑换积分礼品。
        </p>
        <h4>一、	积分活动的对象</h4>
        <p>
          (一)	积分活动的对象为在擎科科邦邦商城中订购产品的终端客户。
        </p>
        <p>
          (二)	凡有以下情形之一的终端客户，不参与积分活动：
        </p>
        <p>1.	擎科科邦邦商城账号被冻结；</p>
        <p>
          (三)	凡有以下情形之一的终端客户，暂停参与积分活动，直至相应情形消失：
        </p>
        <p>
          1.	终端客户的部分或全部订单发生逾期付款；
        </p>
        <p>
          2.	终端客户与公司发生纠纷。
        </p>
        <h4>二、	积分的获取及兑换</h4>
        <p>
          1.	终端客户在擎科科邦邦商城下单是获取积分的主要手段；此外，擎科生物会不定期推出一些活动（以擎科生物发布的具体活动为准），参加这些活动也可以赢取积分。
        </p>
        <p>
          2.	积分分为待激活积分与可用积分。终端客户下单后，即可获得相应数量的待激活积分。待订单开票回款后，待激活积分会在3个工作日之内转化为可用积分，终端客户可使用可用积分在积分商城兑换礼品。待激活积分及可用积分数量可在官网个人中心-积分兑换-积分获取记录中查看。积分兑换订单也可在个人中心-积分兑换-积分兑换订单中查看。
        </p>
        <p>
          3.	订单获取积分数量在订单结算页由擎科生物系统自动计算，通常以实际结算金额1元=1积分取整计算，不足1元的，不计入积分。终端客户可在订单详情中查看该笔订单获取积分值。
        </p>
        <p>
          4.	对于取消订单且尚未付款的订单，擎科生物扣除相应的待激活积分。
        </p>
        <p>
          5.	已付款的订单后续被取消且退款的，擎科生物扣除相应的可用积分。<br/>
        </p>
        <h4>三、	积分有效期</h4>
        <p>
          积分有效期为1年，以积分获得之日起开始计算，凡未在积分有效期内申请兑换礼品的，视为放弃该等权利，积分将做清零处理。
        </p>
        <h4>四、	免责声明</h4>
        <p>
          1.	申请兑换礼品的客户请仔细阅读本政策及相关积分兑换申请流程，凡进行积分兑换者视为不可撤销认可本政策及相关积分兑换申请流程的规定。
        </p>
        <p>
          2.	擎科生物积分商城所兑换的礼品属于终端客户，即申请人所在单位；申请人须确认所在单位已知晓此活动详情和礼品去向，有权操作终端客户账户视为申请人有权代表客户兑换礼品；申请人领取奖励礼品后视为申请人所属单位已收到该奖励礼品，擎科生物不承担礼品发放后的其他责任。
        </p>
        <p>
          3.	礼品兑换申请人需为订单提交者本人，如非本人申请，请出示由申请人书面签字授权的授权书。
        </p>
        <p>
          4.	如发现所兑换商品存在质量及数量问题，申请人需在礼品收到后5个工作日内同擎科生物或当地销售联系。如逾期，则视为已确认无误。
        </p>
        <p>
          5.	擎科生物积分商城所展示礼品均最终以实物为准。
        </p>
        <p>
          6.	根据市场变化，擎科生物保留更换礼品清单或相应积分分值的权利。可供换领、换购的礼品种类以申请当日擎科生物积分换领网站公布内容为准。所有兑换礼品数量有限，限量类礼品先到先得。
        </p>
        <p>
          7.	擎科生物有权根据需要取消本计划或增删、修订本规定。所有规定以擎科生物积分网站最新公布内容为准。
        </p>
        <p>
          8.	擎科生物将在法律许可的范围内保留本政策的最终解释权。
        </p>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rulesVisible = false">取消</el-button>
        <el-button type="primary" @click="rulesVisible = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { pointsGoods, customerPoints } from '@/services/api.index'
export default {
  data () {
    return {
      reliefVisible: false,
      rulesVisible: false,
      goodsLists: [],
      total: 0,
      page: 0,
      size: 12,
      points: {}
    }
  },
  created() {
    this.getGoods()
    this.getPoints()
  },
  methods: {
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getGoods()
    },
    getGoods () {
      const { page, size } = this
      pointsGoods(page,size).then(res => {
        this.goodsLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 商品详情
    toDetails (id) {
      this.$router.push(`/user/product/details?id=${id}`)
    },
    // 立即兑换
    toExchange (item) {
      if (item.price > this.points.availablePoints) {
        this.$confirm('您的积分不足，无法兑换', '提示', {
        })
        return
      }
      this.$router.push(`/user/order_intergal?id=${item.id}`)
    },
    // 积分汇总
    getPoints () {
      customerPoints().then(res => {
        this.points = res.data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/children/mall.vue